import { render } from "./NewBenchmarkFromGeekbench.vue?vue&type=template&id=939d98ac&scoped=true&ts=true"
import script from "./NewBenchmarkFromGeekbench.vue?vue&type=script&lang=ts"
export * from "./NewBenchmarkFromGeekbench.vue?vue&type=script&lang=ts"

import "./NewBenchmarkFromGeekbench.vue?vue&type=style&index=0&id=939d98ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-939d98ac"]])

export default __exports__